import styled, { css } from 'styled-components';
import {
  isDarkThemeMixin,
  Modal,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

export const Wrapper = styled.div`
  position: relative;
  width: 240px;
  flex-shrink: 0;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.xxxlarge.default};
  padding-bottom: ${({ theme }) => theme.spacing.xlarge.default};
  gap: ${({ theme }) => theme.spacing.small.default};
`;

export const TriggerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 100%;
  position: relative;
  border-radius: ${({ theme }) => theme.border.radius.medium};

  input {
    pointer-events: none;
  }

  > span {
    position: absolute;
    right: ${({ theme }) => theme.spacing.xsmall.default};
    top: 50%;
    transform: translateY(-50%);
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    ${styleMixinInvertedFocusOutline};
    ${isDarkThemeMixin(css`
      ${styleMixinFocusOutline};
    `)}
  }
`;

export const SearchContainer = styled.div`
  width: 790px;
  min-height: 168px;
`;

export const ResultsContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.small.default};
`;

export const SearchModal = styled(Modal)`
  align-items: flex-start;
  padding-top: ${({ theme }) => theme.spacing.xxlarge.default};
`;

export const DividerContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.small.default};
  p {
    padding-left: ${({ theme }) => theme.spacing.xsmall.default};
    padding-right: ${({ theme }) => theme.spacing.xsmall.default};
  }
  > div {
    margin-top: ${({ theme }) => theme.spacing.small.default};
    margin-bottom: -${({ theme }) => theme.spacing.xxsmall.default};
  }
`;
